import { unix } from 'dayjs'

import { useStoreContacts } from '@/entities/contact'

import { TIME_FORMAT } from '@/shared/utils/constants'

export const getContact = (imLogin: string) => {
  const { findByPServed } = useStoreContacts()

  return findByPServed(imLogin)
}

export const getTime = (timestamp: number) => {
  const date = unix(timestamp).tz()

  return date.format(TIME_FORMAT)
}
